export var observable = function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();